var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnInstallProblem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 133.49,
    height: 129.251,
    viewBox: "0 0 133.49 129.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.c,.d{fill:#0eb4d0;}.c{opacity:0.25;}.d{opacity:0.175;}.e{opacity:0.467;}.f,.g,.h{fill:none;stroke-linecap:round;}.f{stroke:#007c9f;stroke-width:4px;}.f,.h{stroke-miterlimit:10;}.g,.h{stroke:#0eb4d0;stroke-width:3px;}.g{stroke-linejoin:round;}.i{fill:url(#c);}.j{fill:#e7e6e6;}.k{fill:#8c94c9;}.l{fill:#97d3f1;}.m{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 133.49,
    height: 129.251,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f15a24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8a00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 57.745,
    cy: 55.626,
    rx: 57.745,
    ry: 55.626,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1502.276 -1102.879)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1574.321,1223.128c.971,0,1.844,0,2.716,0,.525,0,1.019.04,1.282.55s-.061.88-.4,1.238q-2.947,3.13-5.894,6.262c-.892.946-1.318.942-2.229-.024-1.967-2.085-3.945-4.162-5.875-6.276a1.533,1.533,0,0,1-.378-1.155c.094-.538.683-.6,1.217-.595.875.005,1.751,0,2.718,0,.019-.315.046-.57.046-.826,0-2.439,0-4.878,0-7.317,0-1.047.27-1.288,1.414-1.29q2,0,3.995,0c1.095,0,1.379.255,1.381,1.246.005,2.439,0,4.878,0,7.317Z",
    transform: "translate(-12.188 -58.906)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(205.119 1065.93)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0S.21,2.68,3.152,5.873c3.236,3.512,4.091,3.138,11.866,2.72,8.413-.454,20.172,4.759,21.359,7.592H.024S-.013.131,0,0Z",
    transform: "translate(1339.19 76.477) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,0s.182,1.346,2.78,2.949C5.643,4.712,6.4,4.524,13.268,4.314,20.7,4.086,31.089,6.7,32.139,8.126H.021S-.011.066,0,0Z",
    transform: "translate(1331.131 76.477) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(2911.153 1257.938) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M.005,0S.22,2.669,3.3,5.849c3.385,3.5,4.28,3.125,12.414,2.709,8.8-.452,21.1,4.739,22.345,7.561H.025S-.013.131.005,0Z",
    transform: "translate(1339.19 76.477) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M.005,0S.22,1.521,3.3,3.334c3.385,1.994,4.28,1.781,12.414,1.544,8.8-.258,21.1,2.7,22.345,4.309H.025S-.013.075.005,0Z",
    transform: "translate(1331.131 76.477) rotate(90)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 63.03,
    height: 42.373,
    rx: 8,
    transform: "translate(1527.068 1140.566)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    y2: 7.995,
    transform: "translate(1554.544 1183.643)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    y2: 7.995,
    transform: "translate(1562.451 1183.643)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 28.377,
    transform: "translate(1544.704 1192.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1538.259,1279.057v5.271s-.076,2.811,1.587,2.811h22.743a2.966,2.966,0,0,0,1.587-2.46v-5.535",
    transform: "translate(6.973 -110.119)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 5.052,
    transform: "translate(1556.301 1150.961)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 5.052,
    transform: "translate(1556.301 1146.139)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M207.253,769h0a1.757,1.757,0,1,1-1.759,1.757A1.757,1.757,0,0,1,207.254,769Zm1.758-4.392V756.7a1.757,1.757,0,0,0-3.514,0V764.6a1.757,1.757,0,0,0,3.514,0ZM193.3,765.924a1.757,1.757,0,0,0,2.418-.572l9.047-14.644a2.925,2.925,0,0,1,4.978,0l12.879,20.847a2.929,2.929,0,0,1-2.489,4.47H207.78a1.757,1.757,0,0,0,0,3.514h12.352a6.443,6.443,0,0,0,5.479-9.831l-12.879-20.847a6.439,6.439,0,0,0-10.958,0L192.727,763.5a1.758,1.758,0,0,0,.572,2.419Z",
    transform: "translate(-113.465 -731.977)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.971 28.012)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.303)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "j",
    cx: 0.875,
    cy: 0.872,
    rx: 0.875,
    ry: 0.872,
    transform: "translate(85.216 25.741)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "k",
    cx: 0.875,
    cy: 0.872,
    rx: 0.875,
    ry: 0.872,
    transform: "translate(10.646 -4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "l",
    cx: 0.875,
    cy: 0.872,
    rx: 0.875,
    ry: 0.872,
    transform: "translate(3 29.79)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.333 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "k",
    cx: 0.875,
    cy: 0.872,
    rx: 0.875,
    ry: 0.872,
    transform: "translate(23.205 67.655)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "l",
    cx: 0.875,
    cy: 0.872,
    rx: 0.875,
    ry: 0.872,
    transform: "translate(36.675 -8.204)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "j",
    cx: 0.875,
    cy: 0.872,
    rx: 0.875,
    ry: 0.872,
    transform: "translate(12 -5)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnInstallProblem);
export default __webpack_public_path__ + "static/media/icn-install-problem.18bca1050341ec79a34c3bc6a93ebbfa.svg";
export { ForwardRef as ReactComponent };